var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDivitMilesLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.513,
    height: 42.513,
    viewBox: "0 0 42.513 42.513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26506",
    "data-name": "Group 26506",
    transform: "translate(-159.001 -14.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Black_underneath",
    "data-name": "Black underneath",
    d: "M19.255,0A19.255,19.255,0,1,1,0,19.255,19.255,19.255,0,0,1,19.255,0Z",
    transform: "translate(160.746 16.317)",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37445",
    "data-name": "Path 37445",
    d: "M621.335,472.079a21.256,21.256,0,1,0,21.256,21.256A21.256,21.256,0,0,0,621.335,472.079ZM610.971,502.21v-6.2h7.087v2.573l9.083-5.244-9.083-5.244v2.574h-7.087v-6.2l7.486-4.322,15.371,8.875v8.644l-15.371,8.874Z",
    transform: "translate(-441.078 -457.765)",
    fill: "#fc3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivitMilesLogo);
export default __webpack_public_path__ + "static/media/divit-miles-logo.826964225c78444a7f707a7829ac7948.svg";
export { ForwardRef as ReactComponent };